import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { useLang } from './context/LanguageContext';
import Home from './pages/Home';
import NotFound from './pages/NotFound';
import './styles/global.css';

const App = () => {
  const { lang, isRTL } = useLang();

  // Apply direction, language, and font to document.body dynamically
  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.body.dir = isRTL ? 'rtl' : 'ltr';
    document.body.style.fontFamily = isRTL
      ? "var(--font-ar)"
      : "var(--font-en)";
  }, [lang, isRTL]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      {/* Catch-all 404 Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default App;
